import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionSkiRack"
const OptionSkiRackIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="m19.5 7.4c0-.695.239-1.492.645-2.303.146-.294.304-.568.461-.813.092-.142.161-.24.194-.284l.6-.8-1.6-1.2-.6.8c-.221.294-.533.781-.845 1.403-.532 1.064-.855 2.142-.855 3.197v14 1h2v-1zm-3 0c0-1.055-.323-2.133-.855-3.197-.312-.622-.624-1.109-.845-1.403l-.6-.8-1.6 1.2.6.8c.033.044.102.142.194.284.157.245.315.519.461.813.406.811.645 1.608.645 2.303v14 1h2v-1zm-5-1h1v14h1v1h-1v1h-1c.884-.246 1.036-1.246.756-2.217-.149-.514-.435-1.108-.756-1.597zm-2 10.667v-10.667h1v11.19c-.285-.183-.62-.355-1-.523zm-7 5.333h2.5l.5-1h2l.55 1h2.45l.5-1c.829 0 .124-1.67-.5-2.5-.617-.82-3-1.5-3-1.5l.55-6h-4.55l-1.5 10z" />
        </svg>
      }
    </span>
  )
}
export default OptionSkiRackIcon
